/**
 * Owner: Masa Bayu
 * File: author-writer-launch.ts
 * Date:Time: 2026-09-16 13:43
 * Description: T6-E1 QXWriter launch intent — external authoring; never hosts QXW.
 */
import { assertNoForbiddenFoundationKey } from './authority';
import { authorizeAuthorSurfaceAccess } from './author-account';
import { assertT6E1SecurityIntact } from './author-security';
import { createQxreadId } from './id';
import { assertTimestamp, assertValidId } from './guards';
/**
 * Issue a launch intent toward QXWriter. Authoring authority stays external.
 */
export function createAuthorWriterLaunchIntent(input) {
    assertNoForbiddenFoundationKey(input, 'QXRead author writer launch');
    assertT6E1SecurityIntact();
    const access = authorizeAuthorSurfaceAccess({
        session: input.session,
        account: input.account,
        authorAccount: input.authorAccount,
    });
    if (!access.allowed) {
        return Object.freeze({ allowed: false, reason: access.reason });
    }
    const createdAt = input.createdAt ?? new Date().toISOString();
    assertTimestamp(createdAt, 'QXRead writer launch createdAt');
    const writerEntryRef = input.writerEntryRef !== undefined ? input.writerEntryRef : 'qxwriter://new';
    if (typeof writerEntryRef !== 'string' || writerEntryRef.trim().length === 0) {
        throw new Error('QXRead writerEntryRef must be a non-empty string');
    }
    assertValidId(input.authorAccount.authorAccountId, 'QXRead authorAccountId');
    return Object.freeze({
        allowed: true,
        intent: Object.freeze({
            intentId: createQxreadId('qxrdwli'),
            authorAccountId: input.authorAccount.authorAccountId,
            accountId: input.authorAccount.accountId,
            writerEntryRef: writerEntryRef.trim(),
            executesAuthoring: false,
            mutatesQxw: false,
            mutatesQxp: false,
            createdAt,
            reason: 'QXWriter launch intent — authoring authority remains external',
        }),
    });
}
//# sourceMappingURL=author-writer-launch.js.map